<template>
	<rmp-sign-in-form-base :title="tc('titles.selectProfile')">
		<rmp-text tag="span" type="body-large" :color="colors.grey.darken1">
			{{ tc("common.selectProfileText") }}
		</rmp-text>

		<v-row>
			<v-col class="pb-2">
				<v-form :readonly="formSaving || formReadonly" :disabled="formDisabled" ref="form" v-model="formValid">
					<rmp-select :items="profiles"
								class="mt-4"
								return-object
								item-text="title"
								item-value="id"
								v-model="selectedProfile">
					</rmp-select>
				</v-form>
			</v-col>
		</v-row>
		<v-row class="flex-column">
			<v-col class="pt-0">
				<rmp-btn @click="handleSubmit"
						 type="submit"
						 :loading="formSaving"
						 color="primary"
						 block>
					{{ tc("buttons.login") }}
				</rmp-btn>
			</v-col>
		</v-row>

		<rmp-digital-signature-dialog @signed="handleSign"
									  v-if="dialogOpened"
									  :payload="dataToBeSigned"
									  v-model="dialogOpened"
									  :mode="DigitalSignatureDialogModeType.SIGN">
		</rmp-digital-signature-dialog>
	</rmp-sign-in-form-base>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpDigitalSignatureDialog, { DigitalSignatureDialogModeType } from "@rmp/core/components/digitalSignature/RmpDigitalSignatureDialog.vue";
import RmpSelect from "@rmp/core/components/fields/RmpSelect.vue";
import RmpSignInFormBase from "@rmp/core/components/form/RmpSignInFormBase.vue";
import { useI18n } from "vue-i18n-composable";
import { useRoute } from "vue-router/composables";
import { useColors } from "@rmp/core/composables/useColors";
import { storeToRefs } from "pinia";
import { computed, Ref, ref } from "vue";
import { useForm } from "@rmp/core/composables/useForm";
import { usePage } from "@rmp/core/composables/usePage";
import { useSelectProfileStore } from "@rmp/id/stores/selectProfile";

const { tc } = useI18n();
const route = useRoute();
const { colors } = useColors();

const useStore = useSelectProfileStore;
const store = useStore();
const { submit } = store;
const { profiles, selectedProfile } = storeToRefs(store);

const dialogOpened = ref(false);
const dataToBeSigned = computed(() => ({
	profileId: selectedProfile.value!.id,
	signedAt: Math.round(Date.now() / 1000)
}));

const handleSign = async (payload: File) => {
	await submit({
		id: selectedProfile.value!.id,
		payload
	});
};
const handleSubmit = () => {
	if(selectedProfile.value!.isSignatureRequired) {
		dialogOpened.value = true;
	} else {
		submit({ id: selectedProfile.value!.id });
	}
};

const {
	form,
	formReadonly,
	formDisabled,
	formSaving,
	formValid
} = useForm({ useStore }, true);

const { initialized, loading } = usePage({ useStore });
</script>
